import { useEffect, useState } from 'react'

/**
 * Botón flotante "volver arriba" para listas largas (menú). Aparece tras
 * desplazar ~400px y lleva la página al inicio. El comensal en mitad del scroll
 * no tenía forma rápida de regresar a las categorías / al código de mesa.
 */
export function ScrollTopButton() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const onScroll = (): void => setShow(window.scrollY > 400)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  if (!show) return null
  return (
    <button
      type="button"
      className="scroll-top-btn"
      aria-label="Volver arriba"
      title="Volver arriba"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <span aria-hidden="true">↑</span>
      <span className="scroll-top-btn__lbl">Volver arriba</span>
    </button>
  )
}
